import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Lead, actions } from '@kanda-libs/ks-frontend-services';

import { useAppDispatch } from 'components/App';
import useCurrentJob from 'hooks/currentJob/currentJob-hook';
import { selectors } from 'store';

interface CurrentJobLeadHook {
  id?: string;
  jobId?: string;
  lead?: Lead;
  hasLead: boolean;
  isLoading: boolean;
  isValidating: boolean;
}

/**
 * Returns current job and loading state
 */
const useCurrentJobLead = (): CurrentJobLeadHook => {
  const dispatch = useAppDispatch();
  const { job } = useCurrentJob();

  const id = job?.quoted_to || undefined;

  const hasFetched = useSelector(selectors.lead.getHasFetched);
  const isLoading = !hasFetched;
  const isValidating = useSelector(selectors.lead.getIsSubmitting);

  const leads = useSelector(selectors.lead.getEntities);
  const lead = id ? leads[id] : undefined;

  useEffect(() => {
    if (id && !lead) {
      dispatch(
        actions.getLead({
          params: { id },
          forceReload: true,
        }),
      );
    }
  }, [id, dispatch, lead]);

  return {
    id: lead?.id || undefined,
    jobId: id,
    lead,
    hasLead: Boolean(id),
    isLoading,
    isValidating,
  };
};

export default useCurrentJobLead;
